import { render, staticRenderFns } from "./cmpgraficodoughnut.vue?vue&type=template&id=58c418a6&"
import script from "./cmpgraficodoughnut.vue?vue&type=script&lang=js&"
export * from "./cmpgraficodoughnut.vue?vue&type=script&lang=js&"
import style0 from "./cmpgraficodoughnut.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports